<template>
  <div class="profile-container" @scroll="handleScroll" ref="scrollContainer">
    <h4 class="main-header" ref="mainHeader">{{ $t('profile.my') }}</h4>
    <div class="profile-column">
      <div
        class="profile"
        :class="{ 'sticky': isSticky }"
        ref="navigation"
      >
        <router-view name="sidebar"></router-view>
      </div>
      <div class="profile-content" ref="profileContent">
        <router-multi-view view-name="tab"></router-multi-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
  data () {
    return {
      isSticky: false,
      headerHeight: 0
    }
  },
  methods: {
    handleScroll () {
      const scrollContainer = this.$refs.scrollContainer
      const mainHeader = this.$refs.mainHeader

      if (scrollContainer && mainHeader) {
        const scrollTop = scrollContainer.scrollTop
        const headerBottom = mainHeader.offsetHeight

        this.isSticky = scrollTop >= headerBottom
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.$refs.mainHeader) {
        this.headerHeight = this.$refs.mainHeader.offsetHeight
      }
    })
  }
}
</script>

<style lang="sass" scoped>
@import "@/variables.sass"

.profile-container
  background: white
  height: calc(100vh - var(--banner-height, 0px))
  display: flex
  flex-direction: column
  overflow-y: auto
  position: relative

.main-header
  position: relative
  z-index: 1
  padding: 20px
  margin: 0
  flex-shrink: 0

.profile-column
  display: flex
  flex-direction: column
  flex: 1
  position: relative

.profile
  width: 100%
  background-color: #FAFAFA
  flex-shrink: 0
  height: auto
  z-index: 10
  transition: all 0.3s ease
  position: relative

  &.sticky
    position: sticky
    top: 0
    background-color: white
    border-bottom: 1px solid #e0e0e0
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)

.profile-content
  background: white
  padding: 20px
  flex: 1

</style>
